export default __webpack_public_path__ + "static/media/notification_active.d97610e6.svg";